/**
 * PostHog analytics — thin wrapper so components import one thing.
 *
 * All events are no-ops if REACT_APP_POSTHOG_KEY is unset (dev/CI safe).
 *
 * NATIVE (iOS/Android via Capacitor): analytics is completely disabled.
 * We do NOT ship the Apple App Tracking Transparency framework (we don't
 * do cross-app / cross-site advertising tracking anywhere in the product),
 * so per Apple Guideline 5.1.2(i) the safest path is to not collect any
 * analytics on the native shell — no banner, no tracker, no ATT prompt.
 * The web/PWA build retains PostHog under GDPR consent for market
 * research.
 */
import posthog from "posthog-js";
import { Capacitor } from "@capacitor/core";

let initialised = false;

export function initAnalytics() {
  if (initialised) return;
  if (Capacitor.isNativePlatform()) return; // Apple 5.1.2(i) — no tracking on native
  const key = process.env.REACT_APP_POSTHOG_KEY;
  if (!key) return;
  posthog.init(key, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
    autocapture: true,
    capture_pageview: true,
    persistence: "localStorage+cookie",
  });
  initialised = true;
}

export function identifyUser(user) {
  if (!initialised || !user?.id) return;
  posthog.identify(user.id, {
    email: user.email,
    role: user.role,
    name: user.name,
  });
}

export function capture(event, properties = {}) {
  if (!initialised) return;
  posthog.capture(event, properties);
}

export function resetAnalytics() {
  if (!initialised) return;
  posthog.reset();
}
